import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { styled, useTheme } from '@mui/system';
import NavigationModule from './NavigationModule';
const StyledListItemButton = styled(ListItemButton) `
  padding-left: 27px;
  & .MuiListItemText-root {
    margin: 0;
    & > span {
      text-overflow: clip;
      white-space: nowrap;
    }
  }
`;
const NavigationButton = ({ label, icon, onClick, isActive = false, currentSubModule = '', subModules = undefined, }) => {
    const theme = useTheme();
    if (subModules) {
        return (_jsx(NavigationModule, { label: label, icon: icon, onClick: onClick, isActive: isActive, currentSubModule: currentSubModule, subModules: subModules }));
    }
    // if there are no submodules, just make a list item
    return (_jsx(ListItem, { disablePadding: true, children: _jsxs(StyledListItemButton, { onClick: onClick, children: [_jsx(ListItemIcon, { sx: { color: isActive ? theme.palette.primary.main : undefined }, children: icon }), _jsx(ListItemText, { primary: label, sx: { color: isActive ? theme.palette.primary.main : undefined }, primaryTypographyProps: { fontSize: '16px' } })] }) }, label));
};
export default NavigationButton;
//# sourceMappingURL=NavigationButton.js.map